/** @format */
import { baseUrl } from "./api";
import axios from "axios";

const prepareHeader = (file = false) => {
  let config;
  if (file) {
    config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    };
  } else {
    config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Accept-Language": "en",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    };
  }

  return config;
};
export const postReq = async (url, params, file) => {
  let config = prepareHeader(file);
  // params = JSON.stringify(params);
  try {
    let response = await axios.post(`${baseUrl}${url}`, params, config);

    return response;
  } catch (error) {
    return error.response;
  }
};
export const putReq = async (url, params, file) => {
  let config = prepareHeader(file);
  // params = JSON.stringify(params);
  try {
    let response = await axios.put(`${baseUrl}${url}`, params, config);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const deleteReq = async (url, params, type) => {
  let config = prepareHeader();
  // params = JSON.stringify(params);
  try {
    let response = await axios.delete(`${baseUrl}${url}`, config);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getReq = async (url, params) => {
  let config = prepareHeader();
  // params = JSON.stringify(params);
  try {
    let response = await axios.get(`${baseUrl}${url}`, config);
    return response;
  } catch (error) {
    return error.response;
  }
};
